import React from 'react';
import { useTranslation } from 'react-i18next';

const IllegalParkingComponent = ({ report, beta }) => {
  const { t } = useTranslation();

  if (!report.illegal_parking_type) {
    return null;
  }

  return (
    <div className="further-details">
      {beta && <div className="border-b my-4 border-[#F4F5F7]" />}
      <h2>Further Details</h2>
      <table>
        <tbody>
          <tr>
            <th>Parking Violation</th>
            <td>{t(`illegal_parking.${report.illegal_parking_type.toLowerCase()}.title`)}</td>
          </tr>
          <tr>
            <th>Reason</th>
            {report.illegal_parking_type === 'illegal' && (
              <td>{t(`illegal_parking.illegal.${report.illegal.toLowerCase()}`)}</td>
            )}
            {report.illegal_parking_type === 'unauthorised' && (
              <td>{t(`illegal_parking.unauthorised.${report.unauthorised.toLowerCase()}`)}</td>
            )}
            {report.illegal_parking_type === 'unpaid' && (
              <td>{t(`illegal_parking.unpaid.${report.unpaid.toLowerCase()}`)}</td>
            )}
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default IllegalParkingComponent;
